const SectionLabel = ({ number, label }) => {
  return (
    <div className="section-label">
      <span className="section-label-num">{number}</span>
      <div className="section-label-line" />
      <span className="section-label-text">{label}</span>
    </div>
  );
};

export default SectionLabel;
